export const DATA_REFRESH_EVENT = 'hoito:data-refresh';
export const OPEN_ADD_MODAL_EVENT = 'hoito:open-add-modal';

export function dispatchDataRefresh() {
  window.dispatchEvent(new CustomEvent(DATA_REFRESH_EVENT));
}

export function dispatchOpenAddModal() {
  window.dispatchEvent(new CustomEvent(OPEN_ADD_MODAL_EVENT));
}

export function useDataRefresh(callback: () => void) {
  return () => {
    const handler = () => callback();
    window.addEventListener(DATA_REFRESH_EVENT, handler);
    return () => window.removeEventListener(DATA_REFRESH_EVENT, handler);
  };
}
